import z from 'zod';

/**
 * Allowed Optimizely event keys. Adding a new event type requires updating
 * this enum — this is intentional to prevent arbitrary keys polluting results.
 */
export const OptimizelyEventKey = z.enum([
  'page_views',
  'form_submits',
  'add_to_carts',
  'click_engagements',
]);
export type OptimizelyEventKey = z.infer<typeof OptimizelyEventKey>;

/**
 * Zod schema for the POST /api/optimizely/events request body.
 * Extracted into a standalone module so it can be imported in tests
 * without triggering Next.js server-side imports.
 */
export const EventBodySchema = z.object({
  eventKey: OptimizelyEventKey,
  url: z.string().optional(),
  properties: z.record(z.string(), z.string()).default({}),
  revenue: z.number().optional(),
  value: z.number().optional(),
});
